<template>
  <div class="subtitle">
    <div
      v-for="checkbox in checkboxes"
      :key="checkbox.id"
      class="subtitle-item"
    >
      <input
        type="checkbox"
        :name="checkbox.name"
        :checked="isSelected(checkbox.name)"
        @change="onChangeCheckbox(checkbox.name)"
      />
      <span :style="{ backgroundColor: checkbox.color }"></span>
      {{ checkbox.label }}
      <span v-b-tooltip.hover :title="checkbox.tooltip" class="icon-tooltip">
        <i class="icofont-info-circle"></i>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Subtitle',
  props: {
    items: {
      type: Array,
      default: () => {},
    },
    reset: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      checkboxes: [
        {
          id: 1,
          name: 'baixo',
          color: '#2cb947',
          label: 'Baixo',
          tooltip: ' <5%',
        },
        {
          id: 2,
          name: 'moderado',
          color: '#bfc300',
          label: 'Moderado',
          tooltip: ' 5% a <10%',
        },
        {
          id: 3,
          name: 'alto',
          color: '#ec7f22',
          label: 'Alto',
          tooltip: ' 10% a <20%',
        },
        {
          id: 4,
          name: 'muitoAlto',
          color: '#bc0020',
          label: 'Muito alto',
          tooltip: ' 20% a <30%',
        },
        {
          id: 5,
          name: 'critico',
          color: '#4d0005',
          label: 'Crítico',
          tooltip: ' >=30%',
        },
      ],
      selectedCheckbox: null,
    }
  },
  watch: {
    reset(newValue) {
      if (newValue === null) {
        this.selectedCheckbox = null
        this.$emit('onChangeCheckbox', this.selectedCheckbox)
      }
    },
  },
  methods: {
    isSelected(checkboxName) {
      return this.selectedCheckbox === checkboxName
    },
    onChangeCheckbox(checkboxName) {
      if (this.selectedCheckbox === checkboxName) {
        this.selectedCheckbox = null
      } else {
        this.selectedCheckbox = checkboxName
      }
      this.$emit('onChangeCheckbox', this.selectedCheckbox)
    },
  },
}
</script>

<style>
.subtitle {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.subtitle-item {
  font-size: 13px;
  margin: 25px 10px;
}
.subtitle-item span {
  width: 15px;
  height: 15px;
  display: inline-block;
  vertical-align: middle;
}

.subtitle-item span i {
  font-size: 14px;
  vertical-align: top;
}

.subtitle .subtitle-item input[type='checkbox'] {
  display: inline-block;
  margin: 0 10px;
  vertical-align: middle;
}

/*
  ##Device = Most of the Smartphones Mobiles (Portrait)
  ##Screen = B/w 320px to 479px
*/

@media (min-width: 320px) and (max-width: 480px) {
  .subtitle {
    justify-content: flex-start;
  }
  .subtitle-item {
    font-size: 13px;
    margin: 10px 10px;
  }
}

/*
  ##Device = Tablets, Ipads (portrait)
  ##Screen = B/w 768px to 1024px
*/

@media (min-width: 768px) and (max-width: 1024px) {
  .subtitle {
    justify-content: flex-start;
  }
  .subtitle-item {
    font-size: 13px;
    margin: 10px 10px;
  }
}
</style>
